import { html, css } from 'lit-element';
import { faFacebookSquare, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { BaseElement } from './BaseElement';
import { Router, STATE_OPERATIONS, Route } from '../Router';

import './MainHeader';
import './MainNavigation';

const _router = Symbol();
const _routerUpdateHandler = Symbol();
const _version = Symbol();
export class PhysicianPortal extends BaseElement {
	constructor() {
		super();
		this[_router] = null;
		this.library.add(faFacebookSquare, faLinkedin);

		this[_routerUpdateHandler] = () => this.requestUpdate();
	}
	static get properties() {
		return { };
	}
	static get styles() {
		return [
			...BaseElement.styles,
			css`
				:host {
					overflow: auto;
					padding: 0.5em;
					margin: 1em;
					display: block;
					color: var(--theme-primary, black);
					background: var(--theme-secondary, white);
					border: var(--theme-border, black);
					border-radius: 0.25em;
					font-family: var(--theme-font-family, Arial);
					font-size: var(--theme-font-size, 16px);
				}
				.disabled {
					pointer-events: none;
				}
				a {
					color: var(--theme-primary, black);
				}
				.footer {
					font-size: 0.75em;
					text-align: center;
				}
				a {
					text-decoration: none;
				}
				.fa-linkedin {
					color: #0e76a8;
				}
				.fa-facebook-square {
					color: #3b5998;
				}
				@media print {
					:host {
						margin: 0;
						border: none;
						padding: 0;
					}
				}
			`
		];
	}
	get router() {
		return this[_router];
	}
	set router(v) {
		if(v !== null && !(v instanceof Router))
			throw new TypeError('router must be an instance of Router.');
		this[_router] = v;
	}
	get version() {
		return this[_version];
	}
	firstUpdated(changedProperties) {
		super.firstUpdated(changedProperties);

		this.router.go(this.window.location.pathname, STATE_OPERATIONS.REPLACE_STATE, this.window.location.href);
	}
	connectedCallback() {
		super.connectedCallback();

		this.emit('get-router', { callback: router => this.router = router });
		this.emit('get-version', { callback: version => this[_version] = version });
		
		this.router.on('update', this[_routerUpdateHandler]);
	}
	disconnectedCallback() {
		super.disconnectedCallback();

		this.router.off(null, this[_routerUpdateHandler]);

		this.router = null;
	}
	render() {
		return html`
			<pp-main-header></pp-main-header>
			<hr/>
			<pp-main-navigation class="no-print"></pp-main-navigation>
			${this.router.current ? this.router.current.template : '' }
			<hr/>
			<div class="footer">
				<a href="https://www.kinexmedical.com">www.kinexmedical.com</a>
				<a href="https://www.facebook.com/kinexmedical">
					<i class="icon fab fa-facebook-square"></i>
				</a>
				<a href="https://www.linkedin.com/company/kinex-medical-company-llc/">
					<i class="icon fab fa-linkedin"></i>
				</a>
				© 2022 Kinex Medical Company, LLC, All Rights Reserved
				/ Version ${this.version}
			</div>
		`;
	}
}

customElements.define('physician-portal', PhysicianPortal);